import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../../_services/auth.service';
import { tap, map, take } from 'rxjs/operators';
import { Router } from '@angular/router';

@Injectable()
export class EditorGuard implements CanActivate {

  constructor(private auth: AuthService,
              private router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> {

    return this.auth.currentUserSubject.pipe(
      take(1),
      map(user => user && user.roles.editor ? true : false),
      tap(isEditor => {
        if (!isEditor) {
          this.router.navigate(['/user']);
        }
      })
    );

  }
}
